import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'

import Page from 'components/common/Page'
import { PartnerForm } from 'components/common/forms/PartnerForm'
import Card from 'components/common/cards/Card'
import Title from 'components/common/Title'
import colors from 'utility/colors'
import { useTenantProfile } from 'hooks/api/tenant/useTenantProfile'

export const PartnerSignupPage = ({ onSignupSuccess }) => {
	const { data: tenantProfile } = useTenantProfile()
	const tenantName = tenantProfile?.name
	const primaryColor = tenantProfile?.theme?.primaryColor
	let title = `Signup and become a ${tenantName} partner!`
	let description = `Signup and become a ${tenantName} partner and help your clients save money on their property taxes!`

	return (
		<Page
			title={title}
			description={description}
			appendTitle={false}
			footer
			footerBackground={colors.WHITE}
			fluid
		>
			<Container style={{ marginTop: 50, marginBottom: 50 }}>
				<Row>
					<Col>
						<Title style={{ fontWeight: 'bold', marginBottom: 20 }}>
							Create a Real Estate Professional Profile
						</Title>
					</Col>
				</Row>
				<Row>
					<Col xs='12' md='11'>
						<PartnerForm signup onSignupSuccess={onSignupSuccess} />
					</Col>
				</Row>
			</Container>
		</Page>
	)
}
